// extracted by mini-css-extract-plugin
export default {"container":"spinner-module__container__APr4o"};